import VirtualDeviceConfigurator from './VirtualDeviceConfigurator';

export default VirtualDeviceConfigurator;
